import { BackendError } from 'libjs-pdcore/backend/BackendError';
import { Extra, Options, Tags } from './ExceptionsService';

interface NormalizeErrorParams {
  error: Error | BackendError | string;
  options?: Options;
}

export const extractOrganizationId = (url: string): string | undefined =>
  /\/org\/(\w{22})\/?/.exec(url)?.[1] || undefined;

export const extractWorkspaceId = (url: string): string | undefined =>
  /\/ws\/(\w{22})\/?/.exec(url)?.[1] || undefined;

export const extractDocumentId = (url: string): string | undefined =>
  /\/documents\/(\w{22})\/?/.exec(url)?.[1] || undefined;

export const extractTemplateId = (url: string): string | undefined =>
  /\/templates\/(\w{22})\/?/.exec(url)?.[1] || undefined;

export const getTagsIdsByUrl = (url: string) => {
  try {
    return {
      organizationId: extractOrganizationId(url),
      workspaceId: extractWorkspaceId(url),
      documentId: extractDocumentId(url),
      templateId: extractTemplateId(url),
    };
  } catch {
    return {};
  }
};

export const extendsNetworkError = ({
  error,
  options,
}: NormalizeErrorParams): NormalizeErrorParams => {
  if (error instanceof BackendError) {
    const {
      searchParams,
      requestBody,
      endpoint,
      responseText,
      responseUrl,
      responseStatus,
    } = error;

    const tags: Tags = {
      ...getTagsIdsByUrl(responseUrl),
      httpCode: responseStatus,
      endpoint,
    };

    const extra: Extra = {
      url: responseUrl,
      status: responseStatus,
      response: responseText,
    };

    if (searchParams) {
      extra.searchParams = searchParams;
    }

    if (requestBody) {
      extra.requestBody = requestBody;
    }

    return {
      error,
      options: {
        ...options,
        fingerprint: ['BackendError', endpoint],
        tags: { ...options?.tags, ...tags },
        extra: { ...options?.extra, ...extra },
      },
    };
  }

  return { error, options };
};
